export default "__VITE_ASSET__faf00d30__"